import {useCallback} from 'react';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import {fetchPartnerAndCountryDriverCost} from '@/Pages/ProductionCost/store/thunks';

const useDriverDefaults = (entryIds: string[]) => {
  const busPartnerAndCountryDriverCostEntry = useAppSelector(
    ({productionCost}) => productionCost.busPartnerAndCountryDriverCostEntry
  );
  const productionCostYear = useAppSelector(
    ({productionCost}) => productionCost.costYear
  ) as number;
  const dispatch = useAppDispatch();

  const getDriverDefaults = useCallback(
    (busPartnerId: string, countryId: string) => {
      const busPartnerAndCountryDriverCostEntryByYear =
        busPartnerAndCountryDriverCostEntry[
          busPartnerId + countryId + productionCostYear
        ];

      if (!busPartnerAndCountryDriverCostEntryByYear) {
        dispatch(
          fetchPartnerAndCountryDriverCost(
            busPartnerId,
            countryId,
            productionCostYear,
            entryIds
          )
        );
        return;
      }

      const {busPartnerDriverCostEntry, countryDriverCostEntry} =
        busPartnerAndCountryDriverCostEntryByYear;

      const accommodationCostPerNight =
        busPartnerDriverCostEntry?.accommodationCostPerNight ??
        countryDriverCostEntry?.accommodationCostPerNight ??
        undefined;
      const dailyAllowance =
        countryDriverCostEntry?.dailyAllowance ?? undefined;
      const prefilledEmptyDistance =
        countryDriverCostEntry?.prefilledEmptyDistance ?? undefined;
      const prefilledEmptyHr =
        countryDriverCostEntry?.prefilledEmptyHr ?? undefined;

      return {
        accommodationCostPerNight,
        dailyAllowance,
        prefilledEmptyDistance,
        prefilledEmptyHr
      };
    },
    [
      busPartnerAndCountryDriverCostEntry,
      productionCostYear,
      entryIds,
      dispatch
    ]
  );

  return {getDriverDefaults};
};

export default useDriverDefaults;
